var trimTrailingZeros = function (minor) {
    var regex = /.*([1-9])[0-9]*$/;
    var match = minor.match(regex);
    if (match) {
        return minor.substring(0, minor.lastIndexOf(match[1]) + 1);
    }
    return minor;
};

export { trimTrailingZeros };
